import { FC } from "react";
import { IconPropsType } from ".";

export const ArrowLeft: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5H1M1 5L4.76471 1M1 5L4.76471 9"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
